import React, { useEffect, useState } from 'react'
import { Button, Checkbox, Popover, Box } from '@mui/material'
import '../../../../style/filters.css'

const SeverityFilter = ({ filterList, onChange, index, column, filterOptions }) => {
  const [tempFilters, setTempFilters] = useState(filterList || [])
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleChange = (event) => {
    const { value, checked } = event.target
    setTempFilters((prev) => (checked ? [...prev, value] : prev.filter((item) => item !== value)))
  }

  const handleApply = () => {
    const cleaned = tempFilters.filter(Boolean)
    onChange(cleaned, index, column)
    handleClose()
  }

  const handleReset = () => {
    setTempFilters([])
    onChange([], index, column)
    handleClose()
  }

  const open = Boolean(anchorEl)
  const id = open ? 'severity-filter-popover' : undefined

  useEffect(() => {
    if (open) {
      setTempFilters(filterList || [])
    }
  }, [open, filterList])

  return (
    <div>
      <Button
        aria-describedby={id}
        onClick={handleClick}
        variant="outlined"
        size="small"
        style={{
          marginLeft: 8,
          borderColor: filterList?.length > 0 ? '#1976d2' : '',
          backgroundColor: filterList?.length > 0 ? 'rgba(25, 118, 210, 0.08)' : '',
        }}
      >
        Severity Filter
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            backgroundColor: '#424242',
            color: '#ffffff',
            padding: '16px',
            width: '300px',
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <div className="filter-title">Severity Filters</div>
          <div style={{ maxHeight: '300px', overflow: 'auto', marginBottom: '16px' }}>
            {filterOptions.severities?.map((severity, i) => {
              const severityStyles = {
                CRITICAL: { bg: '#990000', color: '#fff' },
                HIGH: { bg: '#FF6600', color: '#fff' },
                MEDIUM: { bg: '#FFCC00', color: '#000' },
                MODERATE: { bg: '#FFCC00', color: '#000' },
                LOW: { bg: '#669933', color: '#fff' },
              }

              const style = severityStyles[severity] || { bg: '#95a5a6', color: '#fff' }

              return (
                <div key={i} style={{ display: 'flex', alignItems: 'center' }}>
                  <Checkbox
                    checked={tempFilters.includes(severity)}
                    onChange={handleChange}
                    value={severity}
                    size="small"
                    style={{ color: '#ffffff' }}
                  />
                  <span
                    style={{
                      fontSize: '10px',
                      fontWeight: 'normal',
                      padding: '6px 12px',
                      borderRadius: '16px',
                      display: 'inline-block',
                      textTransform: 'uppercase',
                      textAlign: 'center',
                      backgroundColor: style.bg,
                      color: style.color,
                      marginLeft: '8px',
                      width: '100px',
                    }}
                  >
                    {severity === 'MODERATE' ? 'MEDIUM' : severity}
                  </span>
                </div>
              )
            })}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button onClick={handleReset} className="reset-button-filter">
              Reset
            </button>
            <button onClick={handleApply} className="apply-button-filter">
              Apply
            </button>
          </div>
        </Box>
      </Popover>
    </div>
  )
}

export default SeverityFilter
